import { Col, Input, Row } from "reactstrap"
import Toggle from "../../../../../components/common/Toggle/Toggle"
import styles from "./Availability.module.scss"

const Availability = () => {
  return (
    <div className="mt-3">
      <div className={styles["heading"]}>Two-factor Authentication</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <Row className="g-0 align-items-center">
            <Col xs="4" lg='2'>Online Status:</Col>
            <Col xs="8" lg='10'>
              <Toggle />
            </Col>
          </Row>
          <Row className="g-0">
            <Col xs="4" lg='2'>Availability hours:</Col>
            <Col xs="8" lg='6'>
              <Row className="g-0 gap-2 align-items-center mb-2">
                <Col>
                  <div>On Working days:</div>
                </Col>
                <Col>
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
                <Col>
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
              </Row>
              <Row className="g-0 gap-2 align-items-center">
                <Col>
                  <div>On Weekend:</div>
                </Col>
                <Col>
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
                <Col>
                  <div>
                    <Input placeholder="00:00" />
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="g-0">
            <Col xs="4" lg='2'>Availability hours:</Col>
            <Col xs="8" lg='6'>
              <Input type="textarea" />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  )
}

export default Availability
